import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=824c6748&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=824c6748&prod&scoped=true&lang=css"
import style1 from "./CaseDetail.vue?vue&type=style&index=1&id=824c6748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824c6748",
  null
  
)

export default component.exports